// extracted by mini-css-extract-plugin
export default {"contactMe":"Contact_contactMe__jhGlg","social":"Contact_social__Vv-Wq"};